document.addEventListener("DOMContentLoaded", function () {
  const footerTitleButtons = document.querySelectorAll(
    ".footer__widget-title-button"
  );

  if (footerTitleButtons && footerTitleButtons.length) {
    footerTitleButtons.forEach(function (footerButton) {
      footerButton.addEventListener("click", function () {
        const parentNode = this.parentNode.parentNode;
        const menuFooterContainer =
          parentNode.querySelector("div[class^=menu]");
        console.log("menuFooterContainer", menuFooterContainer);
        if (menuFooterContainer) {
          if (menuFooterContainer.classList.contains("expanded")) {
            menuFooterContainer.classList.remove("expanded");
            footerButton.classList.remove("expanded");
            menuFooterContainer.style.maxHeight = "";
          } else {
            menuFooterContainer.classList.add("expanded");
            footerButton.classList.add("expanded");
            menuFooterContainer.style.maxHeight =
              menuFooterContainer.scrollHeight + "px";
          }
        }
      });
    });
  }
});
